import { faBullseye } from '@fortawesome/pro-regular-svg-icons/faBullseye';
import { faSackDollar } from '@fortawesome/pro-regular-svg-icons/faSackDollar';
import { getAmountSpent } from 'app/modules/insights/utils/getAmountSpent';
import { getObjectivesArray } from 'app/modules/insights/utils/getObjectivesArray';
import { transformObjectives } from 'app/modules/insights/utils/transformObjectives';
import MetricRowSimple from './MetricRowSimple';
import Divider from '../Divider';
import MetricRow from './MetricRow';
import React, { FC } from 'react';
import { ExpenseName, TotalExpenseObject } from 'types/AnalyticsPost';
import { useTranslation } from 'react-i18next';
type Props = {
  totalExpenses: Record<ExpenseName, TotalExpenseObject>;
  pageType: number;
};

const PostInsights: FC<Props> = ({ totalExpenses, pageType }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="tw-text-md tw-font-medium tw-text-grayscale-90">
        {t('insights.postsPerformance.postInsights.sectionTitle')}
      </div>
      <MetricRowSimple
        name="amountSpent"
        icon={faSackDollar}
        label={t('insights.postsPerformance.postInsights.amountSpent')}
        value={getAmountSpent(totalExpenses)}
      />
      <Divider />
      <MetricRow
        pageType={pageType}
        name="usedObjectives"
        icon={faBullseye}
        label={t('insights.postsPerformance.postInsights.usedObjectives')}
        value={getObjectivesArray(totalExpenses)}
        additionalData={transformObjectives(totalExpenses)}
      />
      <Divider />
    </>
  );
};

export default PostInsights;
